import { useEffect } from 'react';
import { X, AlertCircle, CheckCircle, Info } from 'lucide-react';

const AlertModal = ({ isOpen, onClose, type = 'error', title, message }) => {
  useEffect(() => {
    if (isOpen) {
      // ESC tuşu ile kapatma
      const handleEscape = (e) => {
        if (e.key === 'Escape') {
          onClose();
        }
      };
      document.addEventListener('keydown', handleEscape);
      // Body scroll'u engelle
      document.body.style.overflow = 'hidden';
      
      return () => {
        document.removeEventListener('keydown', handleEscape);
        document.body.style.overflow = 'unset';
      };
    }
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const config = {
    error: {
      icon: <AlertCircle className="w-16 h-16 text-red-500" />,
      bgColor: 'bg-red-50',
      iconBg: 'bg-red-100',
      titleColor: 'text-red-900',
      buttonColor: 'bg-red-600 hover:bg-red-700',
    },
    success: {
      icon: <CheckCircle className="w-16 h-16 text-green-500" />,
      bgColor: 'bg-green-50',
      iconBg: 'bg-green-100',
      titleColor: 'text-green-900',
      buttonColor: 'bg-green-600 hover:bg-green-700',
    },
    info: {
      icon: <Info className="w-16 h-16 text-blue-500" />,
      bgColor: 'bg-blue-50',
      iconBg: 'bg-blue-100',
      titleColor: 'text-blue-900',
      buttonColor: 'bg-blue-600 hover:bg-blue-700',
    },
  };

  const style = config[type] || config.error;

  return (
    <div 
      className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[300] flex items-center justify-center p-4 animate-fade-in"
      onClick={onClose}
    >
      <div 
        className={`${style.bgColor} rounded-2xl shadow-2xl max-w-md w-full relative overflow-hidden animate-scale-in`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors duration-200 z-10"
        >
          <X className="w-6 h-6" />
        </button>

        {/* Content */}
        <div className="p-6 sm:p-8 text-center">
          {/* Icon */}
          <div className={`${style.iconBg} w-24 h-24 rounded-full flex items-center justify-center mx-auto mb-4 animate-bounce-in`}>
            {style.icon}
          </div>

          {/* Title */}
          <h3 className={`text-2xl font-bold ${style.titleColor} mb-2`}>
            {title}
          </h3>

          {/* Message */}
          <p className="text-gray-600 text-base leading-relaxed mb-6">
            {message}
          </p>

          {/* Button */}
          <button
            onClick={onClose}
            className={`${style.buttonColor} text-white px-8 py-3 rounded-lg font-semibold transition-all duration-300 transform hover:scale-105 hover:shadow-lg`}
          >
            Tamam
          </button>
        </div>
      </div>
    </div>
  );
};

export default AlertModal;

